<template>
  <div class="form-text" :style="style">
    <span @click="inputClick" v-if="$store.state.assigningIndexes" class="tab-index" :style="tabOrderStyle">
      {{ ($store.getters.templateTabOrder(id) > -1) ? $store.getters.templateTabOrder(id) : '?' }}
    </span>
    <input
      type="text"
      @focus="focusInput"
      @blur="noFocus"
      v-mask="getMask"
      :style="inputStyle"
      :class="fieldClass"
      @keyup="scaleText"
      @contextmenu="inputClick"
      :id="id"
      :tabindex="$store.getters.templateTabOrder(id)"
      v-model="value"
      :data-model="model"
    >
    <div :id="'hidden-' +id" :style="hiddenDiv">{{ value }}</div>
  </div>
</template>

<script>
  import mixinEditor from '@/mixins/editor.js'

  export default {
    name: 'form-text',

    mounted () {
      this.$bus.$on('setPageScale', this.scaleText)

      this.indiceScroll = 0
    },

    mixins: [mixinEditor],

    data () {
      return {
        displayFontSize: 12,
        indiceScroll: 0
      }
    },

    methods: {
      noFocus () {
        this.$bus.emit('scrollToElement', this.id)

        this.hideAutocomplete()
      },

      focusInput () {
        const highlighted = document.querySelectorAll('.id-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('id-highlight')
        }
        this.$bus.emit('scrollToElement', this.id)
      },

      inputClick (e) {
        e.preventDefault()
        this.$bus.emit('openFieldMenu', {
          id: this.id,
          pos: { x: e.pageX, y: e.pageY },
          tabOrder: this.$store.getters.templateTabOrder(this.id)
        })
      },

      scaleText (e) {
        if (typeof e !== 'number') this.setAutocompleteModel()

        if (!this.value.length) {
          this.displayFontSize = this.fontSize
          return
        }
        const input = document.getElementById(this.id)
        const div = document.getElementById('hidden-' + this.id)
        if (div === null) return
        if (div.offsetWidth >= input.offsetWidth) {
          this.displayFontSize--
        } else if (div.offsetWidth <= input.offsetWidth && this.displayFontSize < this.fontSize) {
          this.displayFontSize++
        }
      }
    },

    props: [
      'id',
      'width',
      'height',
      'left',
      'top',
      'fontSize',
      'model'
    ],

    computed: {
      style () {
        let styleStr = 'position: absolute;'
        styleStr += 'width: ' + this.width + 'px;'
        styleStr += 'height: ' + this.height + 'px;'
        styleStr += 'left: ' + this.left + 'px;'
        styleStr += 'top: ' + this.top + 'px;'
        styleStr += 'font-size: ' + this.fontSize + 'px;'
        return styleStr
      },

      tabOrderStyle () {
        let tabStyleStr = ''
        tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;'
        return tabStyleStr
      },

      fieldClass () {
        let fieldData = this.$store.getters.currentTemplateField(this.id)
        let maskType = fieldData['maskType']
        if (maskType === undefined || !maskType.length) return ''
        return 'mask-' + maskType.toLowerCase().replace(/ /g, '-').replace(/[()]/g, '')
      },

      inputStyle () {
        return this.model !== '' &&
          this.value &&
          this.value.indexOf('#') === -1 &&
          this.value.indexOf('+') === -1 &&
          this.value.indexOf('(') === -1 &&
          this.value.indexOf(')') === -1 &&
          this.listOfficialModels.length > 0 &&
          this.listOfficialModels.map(a => a.model).indexOf(this.value) === -1
            ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;'
            : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;'
      },

      hiddenDiv () {
        return 'display:inline-block;z-index:-1;opacity:0;font-size:' + this.displayFontSize + 'px;'
      },

      getMask () {
        let fieldData = this.$store.getters.currentTemplateField(this.id)
        let maskType = fieldData['maskType']
        if (maskType === 'Phone (US)') return '(###) ###-####'
        if (maskType === 'Phone (International)') return '+## ### #######'
        if (maskType === 'Email Address') return 'A@A'
        if (maskType === 'Zip Code') return '#####?-####'
        if (maskType === 'Date') return '##/##/####'
        if (maskType === 'Date (ISO 8601)') return '####/##/##'
        if (maskType === 'Alien Number') return '###-###-###'
        if (maskType === 'EIN') return '##-#######'
        if (maskType === 'Social Security Number') return '###-##-####'
        if (maskType === 'US Dollars') return '$#,###,###.##'
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab-index {
    user-select: none;
    position: absolute;
    top: -5%;
    min-width: 22px;
    min-height: 22px;
    background-color: #5E738B;
    border: 2px solid #333;
    color: #FFF;
    text-align: center;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      outline: 3px dashed blue;

      &+input {
        outline: 2px dashed blue !important;
      }
    }
  }

  input[type=text] {
    width: 100%;
    height: 100%;
    padding-left: 3px;
    z-index: 10;
    &:hover {
      outline: green 3px solid;
    }
    &:focus {
      outline: rgb(3, 216, 170) solid 3px;
    }
    // &:focus {
    //   outline: green solid 3px;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/inputs/FormText.vue